export class StatusTransformer {
  static transform(obj) {
    let status = {};
    status.id = obj.id;
    status.code = obj.attributes.code;
    status.name = obj.attributes.name;
    status.type = obj.attributes.type;
    return status;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/statuses/status.transformer.js